import { MessageCircle, Mail, FileText, Heart } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const WHATSAPP_URL = 'https://wa.me/917398073200?text=Hi%20MenuRank%20AI';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="py-12 border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <a href="#" className="flex items-center gap-2 group">
              <img 
                src="https://customer-assets.emergentagent.com/job_aifood-photos/artifacts/qg73uxzb_ChatGPT%20Image%20Feb%202%2C%202026%2C%2002_28_25%20PM.png" 
                alt="MenuRank AI"
                className="w-10 h-10 rounded-xl object-contain group-hover:scale-110 transition-transform duration-200"
              />
              <span className="text-xl font-semibold text-white">MenuRank AI</span>
            </a>
            <p className="text-white/50 text-sm flex items-center gap-1">
              <Heart className="w-3 h-3 text-[#F59E0B] fill-[#F59E0B]" /> {t.footer.tagline}
            </p>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white/60 hover:text-[#25D366] transition-colors duration-200"
              data-testid="footer-whatsapp"
            >
              <MessageCircle className="w-5 h-5" />
              <span className="text-sm">{t.footer.whatsapp}</span>
            </a>
            <a
              href="mailto:mohitpassivework2024@gmail.com?subject=MenuRank%20AI%20Inquiry"
              className="flex items-center gap-2 text-white/60 hover:text-white transition-colors duration-200"
              data-testid="footer-email"
            >
              <Mail className="w-5 h-5" />
              <span className="text-sm">{t.footer.email}</span>
            </a>
            <a
              href="#"
              className="flex items-center gap-2 text-white/60 hover:text-white transition-colors duration-200"
              data-testid="footer-terms"
            >
              <FileText className="w-5 h-5" />
              <span className="text-sm">{t.footer.terms}</span>
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-white/5 text-center">
          <p className="text-white/30 text-sm">
            © {new Date().getFullYear()} MenuRank AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
